export default [
  {
    path: '/seller/list',
    name: 'seller-list',
    component: () => import('@/views/seller/members-list/MembersList.vue'),
    
  },
  {
    path: '/seller/view/:id/:isEdit',
    name: 'seller-view',
    component: () => import('@/views/seller/members-view/MembersView.vue'),
    
  },
  {
    path: '/seller/edit/:id',
    name: 'seller-edit',
    component: () => import('@/views/seller/members-edit/MembersEdit.vue'),
   
  },
  {
    path: '/seller/add',
    name: 'seller-add',
    component: () => import('@/views/seller/members-edit/MembersEdit.vue'),
  },
  {
    path: '/user/list',
    name: 'user-list',
    component: () => import('@/views/user/members-list/MembersList.vue'),
    
  },
  {
    path: '/user/view/:id/:isEdit',
    name: 'user-view',
    component: () => import('@/views/user/members-view/MembersView.vue'),
    
  },
  {
    path: '/user/edit/:id',
    name: 'user-edit',
    component: () => import('@/views/user/members-edit/MembersEdit.vue'),
   
  },
  {
    path: '/user/add',
    name: 'user-add',
    component: () => import('@/views/user/members-edit/MembersEdit.vue'),
  },
]
